<header
  class="fixed top-0 left-0 right-0 z-10 border-b border-[#D7E4F4] h-[80px] backdrop-blur-md"
>
  <div
    class="w-full h-full max-w-[2560px] mx-auto flex items-center justify-between pl-sm pr-sm"
  >
    <!-- LEFT -->
    <div class="flex items-center gap-3 sm:gap-6 min-w-0 flex-1 mr-2 sm:mr-4">
      <!-- Logo -->
      <div class="flex items-center gap-3 sm:gap-6 min-w-0 max-w-full">
        <app-logo class="shrink-0"></app-logo>
        <span class="w-px h-6 border-line border shrink-0"></span>
        <nav class="flex flex-col gap-0.5 sm:gap-1 min-w-0 max-w-full">
          <!-- First line: Title (from first breadcrumb item) -->
          <span class="font-bold text-sm sm:text-md text-dark-text font-josefin truncate">
            {{ pageTitle() | translate }}
          </span>

          <!-- Second line: Navigation Breadcrumb -->
          <div
            class="flex items-center justify-start gap-xsl text-xs min-w-0 max-w-full overflow-x-auto no-scrollbar whitespace-nowrap py-0.5"
          >
            @if (rootBreadcrumb(); as root) {
            <a
              [routerLink]="[root.route]"
              (mousedown)="$event.preventDefault()"
              [title]="'home' | translate"
              class="cursor-pointer text-xs hover:text-secondary group transition-colors flex items-center outline-none widget-focus-ring shrink-0"
            >
              <ic-home
                startColor="var(--color-primary-start-color)"
                endColor="var(--color-primary-end-color)"
              ></ic-home>
            </a>
            @for (item of remainingBreadcrumbs(); track item.id; let idx = $index) {
            <span class="text-light-text shrink-0 select-none">›</span>

            @if (showShipmentBreadcrumbNav(item, idx)) {
            <app-breadcrumb-shipment-nav class="shrink-0 min-w-0"></app-breadcrumb-shipment-nav>
            } @else {
            <a
              [routerLink]="[item.route]"
              [class.pointer-events-none]="!item.route"
              (mousedown)="$event.preventDefault()"
              (click)="onBreadcrumbClick(item, $event)"
              [title]="item.isDynamic ? item.itemName : (item.itemName | translate)"
              class="text-xs text-gray-text hover:text-secondary transition-colors outline-none widget-focus-ring truncate max-w-[120px] sm:max-w-[180px] md:max-w-[240px] lg:max-w-none inline-block shrink-0"
            >
              @if (item.isDynamic) {
              {{ item.itemName }}
              } @else {
              {{ item.itemName | translate }}
              }
            </a>
            }
            } }
          </div>
        </nav>
      </div>
      <!-- Breadcrumb -->
    </div>

    <!-- RIGHT -->
    <div class="flex items-center gap-xs sm:gap-sm shrink-0">
      <!-- E2E Test Runner (local & dev only) -->
      @if (isDevEnv) {
      <app-e2e-test-runner></app-e2e-test-runner>
      <button
        type="button"
        class="flex items-center justify-center w-9 h-9 rounded-full bg-white shadow-card hover:scale-105 transition-all outline-none cursor-pointer widget-focus-ring"
        [matTooltip]="'testAuditLog' | translate"
        matTooltipPosition="below"
        [attr.aria-label]="'testAuditLog' | translate"
        (click)="openTestAuditLog()"
      >
        <ic-tasks
          [width]="14"
          [height]="14"
          startColor="var(--color-primary-start-color)"
          endColor="var(--color-primary-end-color)"
        ></ic-tasks>
      </button>
      }


      <!-- Search Trigger -->
      <button
        type="button"
        (mousedown)="$event.preventDefault()"
        (click)="onGlobalSearchClick()"
        class="flex items-center justify-between gap-sm h-9 px-sm rounded-full bg-white shadow-card text-gray-text text-sm font-medium
               hover:scale-105 transition-all outline-none cursor-pointer widget-focus-ring w-48 md:w-60 lg:w-64"
        [attr.aria-label]="'search' | translate"
      >
        <div class="flex items-center gap-sm min-w-0">
          <ic-search
            startColor="var(--color-primary-start-color)"
            endColor="var(--color-primary-end-color)"
            [opacity]="0.6"
          ></ic-search>
          <span class="hidden md:inline truncate">{{ 'search' | translate }}</span>
        </div>
        <kbd class="hidden lg:inline-flex items-center px-1.5 py-0.5 rounded bg-white text-[10px] font-bold text-gray-400 border border-gray-200">
          {{ searchShortcut() }}
        </kbd>
      </button>


      <!-- Notification -->
      <button
        type="button"
        (mousedown)="$event.preventDefault()"
        class="w-9 h-9 rounded-full bg-white shadow-card flex items-center justify-center cursor-pointer hover:scale-110 transition-all outline-none widget-focus-ring"
        (click)="onNotificationClick()"
        [matTooltip]="'notifications' | translate"
        matTooltipPosition="below"
      >
        <ic-notification
          startColor="var(--color-primary-start-color)"
          endColor="var(--color-primary-end-color)"
          [opacity]="0.6"
        ></ic-notification>
      </button>



      <!-- Profile -->
      <button
        type="button"
        (mousedown)="$event.preventDefault()"
        class="w-9 h-9 rounded-full bg-white shadow-card flex items-center justify-center cursor-pointer hover:scale-110 transition-all outline-none widget-focus-ring"
        (click)="onProfileClick()"
        [matTooltip]="'profile' | translate"
        matTooltipPosition="before"
      >
        <ic-user
          startColor="var(--color-primary-start-color)"
          endColor="var(--color-primary-end-color)"
          [opacity]="0.6"
        ></ic-user>
      </button>
    </div>
  </div>
</header>
